import AuthService from "@/services/AuthService";
import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
// start
const stepper = {
  namespaced: true,
  state: () => ({
    emailExists: true,
    subRolesList:[
      {
        id: "Coach",
        name: $gettext("I'm a Coach"),
      },
      {
        id: "Golfer",
        name: $gettext("I'm a Golfer"),
      },
      {
        id: "Vlogger",
        name: $gettext("I'm a Vlogger"),
      },
    ],
    step: 1,
    isInfomation: false,
    //check form has fill
    checkForm: true,
    formRegistMember: {
      email: '',
      password: '',
    },
    fromInformation: {
      firstName: '',
      lastName: '',
      city: '',
      phone: '',
      country: '',
      subRoles: [],
    }
  }),
  getters: {
    getUserInfomationArray: state => {
      let result = Object.keys(state.fromInformation).map((item) => Object.assign({ name: item }, { value: state.fromInformation[item] }));
      result.pop();
      return result;
    },
    registerData: state => {
      return {
        ...state.formRegistMember,
        ...state.fromInformation,
      }
    }
  },
  //mutations are synchronous transactions
  mutations: {
    increate(state) {
      if (state.step === 1) state.step++;
      // if fill all information user
      if (state.checkForm) {
        state.isInfomation = true;
      }
    },
    editInformation(state) {
      // state.step--;
      state.isInfomation = false
    },
  },
  //make mutations synchronous
  actions: {
    asyncIncreate({ commit }) {
      setTimeout(() => {
        commit('increate')
      }, 2000)
    },
    async emailExists({state}, email){
      let data = await AuthService.emailExists(email);
      state.emailExists = data && data.result;
    },
  },
}

export default stepper;